import React, { Component } from 'react';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';

import { FormattingUtils } from '../../../utils';
import { ILoan } from '../../../interfaces';

import { IAllocationDraft, allocationTotal } from './allocations';

const { formatMoney } = FormattingUtils;

interface IProps {
  allocation: IAllocationDraft;
  closesLoan: boolean;
  loan?: ILoan;
  onChange: (loanId: string, field: 'amount_to_interest' | 'amount_to_principal', value: string) => void;
  onCloseChange: (loanId: string, closesLoan: boolean) => void;
}

/**
 * One loan's share of the payment, editable.
 *
 * A component of its own rather than a row rendered inline, so that the two change handlers can be
 * bound methods -- a lambda in a JSX attribute is a new function on every render, which is what
 * TermsTableRow exists for on the terms table.
 */
@autoBindMethods
@observer
class PaymentAllocationRow extends Component<IProps> {
  private onInterestChange (event: React.ChangeEvent<HTMLInputElement>) {
    this.props.onChange(this.props.allocation.loan, 'amount_to_interest', event.target.value);
  }

  private onPrincipalChange (event: React.ChangeEvent<HTMLInputElement>) {
    this.props.onChange(this.props.allocation.loan, 'amount_to_principal', event.target.value);
  }

  private onCloseChange (event: React.ChangeEvent<HTMLInputElement>) {
    this.props.onCloseChange(this.props.allocation.loan, event.target.checked);
  }

  public render () {
    const { allocation, closesLoan, loan } = this.props;

    return (
      <tr>
        {/* Loans are known to users by their vanity id, as they are on the loans table. */}
        <td>{loan ? `Loan ${loan.vanity_id}` : 'Loan'}</td>
        <td>
          <input
            className='form-control'
            min='0'
            onChange={this.onInterestChange}
            step='0.01'
            type='number'
            value={allocation.amount_to_interest}
          />
        </td>
        <td>
          <input
            className='form-control'
            min='0'
            onChange={this.onPrincipalChange}
            step='0.01'
            type='number'
            value={allocation.amount_to_principal}
          />
        </td>
        <td className='text-right'>{formatMoney(allocationTotal(allocation))}</td>
        {/* Input and label together, as the lien return table does it: checkbox.scss hides the
            input and draws the box with the label's own :before, so one without a label is an
            empty cell. */}
        <td className='col-close-loan'>
          <div>
            <input
              checked={closesLoan}
              className='close-loan-checkbox'
              id={`close-loan-checkbox-${allocation.loan}`}
              onChange={this.onCloseChange}
              type='checkbox'
            />
            <label htmlFor={`close-loan-checkbox-${allocation.loan}`} />
          </div>
        </td>
      </tr>
    );
  }
}

export default PaymentAllocationRow;
